import { CoatDto } from 'src/dto/coat.dto'
import { CoatService } from 'src/services/api/coat.service'

export class CoatController {
  private service: CoatService

  constructor() {
    this.service = new CoatService()
  }

  public async getCoatList(): Promise<CoatDto[]> {
    const response = await this.service.getCoatList()
    const dataOrdered = response.data.sort((a: CoatDto, b: CoatDto) => a.descricao!.localeCompare(b.descricao!))
    return dataOrdered
  }
}
